// extracted by mini-css-extract-plugin
export default {"searchResult":"MobileHomeView_searchResult__PxC-n"};